import { BiteLogPusherEvent } from './bite_log_pusher_event.js';

export function name(event: BiteLogPusherEvent): string {
  switch (event) {
    case BiteLogPusherEvent.Ok:
      return 'ok';
    case BiteLogPusherEvent.Connected:
      return 'connected';
    case BiteLogPusherEvent.Subscribed:
      return 'subscribed';
    case BiteLogPusherEvent.Disconnected:
      return 'disconnected';
    case BiteLogPusherEvent.FailedToConnect:
      return 'failed-to-connect';
    case BiteLogPusherEvent.FailedToSubscribe:
      return 'failed-to-subscribe';
    case BiteLogPusherEvent.Error:
      return 'error';
    case BiteLogPusherEvent.Initialized:
      return 'initialized';
  }
}
